<template>
  <div v-if="mode == 'bar'">
    <div class="wrapper-semaforo con-ombra">
      <v-btn
        v-if="buttons.includes('play')"
        small
        rounded
        depressed
        class="secondary white--text ma-0 px-2 btn-avvia"
        @click="avviaAsta"
        :disabled="!((asta_info.counter > 0 || premium) && !isAstaInCorso)"
      >
        <v-icon small light left>play_arrow</v-icon>
        Avvia
      </v-btn>

      <!--
      Pausa temporaneamente disabilitata.
      <v-btn
        v-if="buttons.includes('pause')"
        icon
        small
        depressed
        class="orange white--text ma-0"
        @click="pausaAsta"
        :disabled="!running"
      >
        <v-icon small light>pause</v-icon>
      </v-btn>
      -->

      <v-btn
        v-if="buttons.includes('stop')"
        small
        :rounded="!is_mobile"
        :icon="is_mobile"
        depressed
        class="red lighten-1 white--text ma-0"
        :class="{ 'px-2': !is_mobile }"
        @click="fermaAsta"
        :disabled="!isAstaInCorso"
      >
        <v-icon small light :left="!is_mobile">stop</v-icon>
        <span v-if="!is_mobile">Stop</span>
      </v-btn>
    </div>

  </div>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Vuex from "vuex";
import Config from "../../../config-app/config";

export default {
  name: "semaforo",
  mixins: [mixins, toast],
  components: {},
  props: {
    mode: {},
    buttons: {
      default: () => ["play", "stop"],
      type: Array,
    },
  },
  mounted() {
    console.log("--> Semaforo ready.");
  },
  destroyed() {
    console.log("<-- Semaforo destroyed.");
  },
  computed: {
    ...Vuex.mapGetters([
      "tot_squadre",
      "listoneStatus",
      "listoneStatusMsg",
    ]),
  },
  data() {
    return {
      // tavoloSize: 0,
      processing: false,
    };
  },
  methods: {
    closeDrawer() {
      if (this.mode !== "bar") {
        db.emit("closeDrawer");
      }
    },
    showChooser() {
      db.emit("showChooser");
    },
    avviaAsta() {
      if (this.listoneStatus === 0) {
        Swal.fire({
          title: "Impossibile avviare asta",
          text: this.listoneStatusMsg,
          icon: "warning",
          confirmButtonText: "Ok, ho capito",
        });
        return;
      }

      if (this.tot_squadre === 1) {
        Swal.fire({
          title: "Attenzione",
          text: "Sei l'unico iscritto alla lega. Bisogna essere almeno in 2 per avviare l'asta",
          icon: "warning",
        });
        return;
      }

      if (
        !Config.STANDALONE &&
        this.asta_info.statoMercato == Constants.MERCATO_NON_ATTIVO
      ) {
        this.promptStatiMercati();
        return;
      }

      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }

      // MODALITA' ASSEGNA
      if (this.mode_assegna) {
        if (!this.asta_round.calciatoreInAsta) {
          db.resetRound(this.user_uid).then(
            db.setSetting("status", Constants.ASTA_STATUS.RUNNING)
          );
        } else {
          db.setSetting("status", Constants.ASTA_STATUS.RUNNING);
        }
      }

      // ALTRE MODALITA'
      if (this.mode_poker || this.mode_selvaggia || this.mode_bustachiusa) {
        // Bisogna scegliere CHOOSER?
        if (this.asta_round.calciatoreInAsta) {
          db.setSetting("status", Constants.ASTA_STATUS.RUNNING);
        } else {
          if (
            this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL ||
            this.asta_settings.ch_mode === Constants.CHOOSER_MODE.MANUAL_PASSO
          ) {
            this.showChooser();
          } else if (
            this.asta_settings.ch_mode === Constants.CHOOSER_MODE.ADMIN
          ) {
            db.setChooser(this.adminUid).then(
              db.setSetting("status", Constants.ASTA_STATUS.RUNNING)
            );
          }
        }
      }
      this.astaLogRoundStart();
      this.closeDrawer();
    },
    promptStatiMercati() {
      db.emit("showStatiMercati");
    },
    pausaAsta(setLog = true) {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      // EMIT -> se è già "not_running" emetto comunque evento "status" per notificarlo a FP
      let emit = this.not_running;
      return db
        .setSetting("status", Constants.ASTA_STATUS.NOT_RUNNING)
        .then(() => {
          if (emit) {
            db.emit("status", Constants.ASTA_STATUS.NOT_RUNNING);
          }
          if (setLog) {
            this.astaLogRoundPause();
          }
          this.closeDrawer();
        })
        .catch(() => {
          this.errorToast("Errore", "Operazione non consentita!");
        });
    },
    fermaAsta() {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }

      let confirmStop = localStorage.getItem("confirmStop") || "T";
      if (confirmStop == "T") {
        Swal.fire({
          title: "Vuoi fermare l'asta?",
          text: "Proseguendo annullerai anche un eventuale round in corso",
          icon: "warning",
          input: "checkbox",
          inputPlaceholder: "Non chiedermi più questa conferma",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
          confirmButtonColor: "tomato",
          cancelButtonColor: "#BDBDBD",
        }).then((result) => {
          if (result.isConfirmed == true) {
            //salva in localstorage
            if (result.value) {
              localStorage.setItem("confirmStop", "F");
            }
            this.pausaAndReset();
          }
        });
      } else {
        this.pausaAndReset();
      }
    },
    pausaAndReset() {
      this.pausaAsta(false).then(() => {
        db.resetRound(this.asta_round.chooser).then(() => {
          this.astaLogRoundStop();
        });
      });
    },
  },
};
</script>

<style scoped>
.wrapper-semaforo {
  background: var(--fp_dark_7);
  padding: 5px;
  border-radius: 100px;
}
.wrapper-semaforo .v-btn--disabled {
  opacity: 0.3;
}

.btn-avvia{
  box-shadow: 0px 0px 12px 2px rgba(246, 189, 0, 0.8);
}
</style>
